<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5">
      <div class="bootstrap-dialog-title">Share registration Link</div>
    </h2>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="share-link-container">
      <p class="info-text">
        Share this link with users to allow them to self-register and join your organization.
      </p>

      <div class="generated-link-section">
        <div class="link-input-group">
          <input
            type="text"
            class="form-control link-input"
            [value]="generatedLink"
            readonly
            #linkInput
          />
          <button class="btn-copy" (click)="copyLink(linkInput)" [class.copied]="linkCopied">
            <i class="fa" [ngClass]="linkCopied ? 'fa-check' : 'fa-copy'"></i>
            {{ linkCopied ? 'Copied!' : 'Copy' }}
          </button>
        </div>
      </div>

      <div class="form-group mt-5">
        <h6 class="things-to-keep-title"><strong>Things to keep in mind:</strong></h6>
        <div class="info-notification-clean">
          <span class="bullet">•</span>
          Users created via the shared link will be assigned the Member role. Once the user
          registers and verifies their email, you will receive an email notification.
        </div>
        <div class="info-notification-clean mt-2">
          <span class="bullet">•</span>
          You must activate the user to complete their onboarding.
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Close</button>
  </div>
</div>
